var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3557 6.80283C13.3557 7.61283 13.1319 8.37055 12.7427 9.01753H12.7591L9.44357 14.2843C9.26241 14.572 8.84287 14.5719 8.66191 14.284L5.35163 9.01753H5.36297C4.97381 8.37055 4.75 7.61283 4.75 6.80283C4.75 4.42644 6.67644 2.5 9.05283 2.5C11.4292 2.5 13.3557 4.42644 13.3557 6.80283ZM9.05274 7.90851C9.71005 7.90851 10.2429 7.37566 10.2429 6.71835C10.2429 6.06103 9.71005 5.52818 9.05274 5.52818C8.39543 5.52818 7.86257 6.06103 7.86257 6.71835C7.86257 7.37566 8.39543 7.90851 9.05274 7.90851Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f9c2c86a28390f3b780eebc0031c10fe.svg";
export { ForwardRef as ReactComponent };